import styled, { css } from 'styled-components';
import { MainWrapper } from 'commonStyles';
import { ListWrapper } from 'common/ListStyles';


export const BudgetOverviewWrapper = styled.div`
  position: relative;
  min-height: 230px;
`;

export const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const HeadingDtls = styled.div`
  flex: 1;

  & h3 {
    font-size: 24px;
    font-weight: 700;
    color: #000;
    margin-bottom: 3px;
  }

  & p {
    color: #777;
  }
`;

export const BudgetOverviewContainer = styled.div`
  padding: 16px;
  background: #f9fafb;
  border-radius: 14px;
  border: 1px solid #f9fafb;
  ${(props) =>
    props.active &&
    css`
      position: relative;
      z-index: 2;
    `}

  ${(props) =>
    props.isDisabled &&
    css`
      position: relative;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #fff;
        opacity: 0.66;
        z-index: 1;
      }
    `}
`;

export const BudgetListingWrapper = styled(ListWrapper)`
  & .wallet_cell_head {
    font-style: normal;
    font-weight: 500;
    text-transform: uppercase;
    color: #9b9b9b;
  }

  & .report_table {
    box-shadow: none;
    background: #fff;
    position: relative;
  }

  & .wallet_cell {
    font-size: 14px;
  }

  box-shadow: 0 4px 6px -1px #e8eef2;
`;

export const BudgetSelectedWrapper = styled.div`
  padding: 8px;
  border-radius: 8px;
  background: #fff;
  margin-bottom: 20px;
`;

export const BudgetOverview = styled.div`
  display: flex;
  gap: 16px;
`;

export const BudgetOverviewItem = styled.div`
  width: 223px;
  padding: 20px 12px;
  border: 1px solid #e8eef2;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 6px -1px #e8eef2;
  margin-bottom: 20px;
`;

export const BudgetDashIcon = styled.img`
    width: 18.87px;
    height: 17.87px;
    display: inline-block;
    border-radius: 6px;
    color: #FF664B;
    border: 1px solid;
    padding: 2px;
    margin-top: 2px;
    margin-right: 6px;
`;

export const StatusCell = styled.div`
  background-color: #F1F5F9;
  border-radius: 12px;
  color: #324158;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 700;
`;

export const CrossIconWrapper = styled.div`
  padding: 0px 0px 40px 16px;
  display: flex;
  align-items: center;
  height: 32px;
  cursor: pointer;
  z-index: 1;
`;

export const BudgetManagementRightSection = styled.div`
	width: ${(p) => p.$width || 'calc(100% - -375px)'};
  font-family: 'lato';
  margin-right: -80px;
  margin-left: 80px;
  @media (max-width: 768px) {
    width: 100%;
		display: ${(p) => p.mobHide ? 'none' : 'block'};
  }
    `;

export const FiletrResetIcon = styled.img`
  width: 100%;
  height: 26px;
`;